import { Toast } from '@kibt/meta-ui';
import { isIOS } from '@/common/device-info';
import { $k18n } from '@/common/i18n';

enum OpenStatus {
    SUCCESS = 'SUCCESS',
    UNKNOWN = 'UNKNOWN',
    FAILED = 'FAILED',
}

export interface CallAppOption {
    channel: string; // 分享的渠道

    // 以下字段名取自 https://docs.corp.kuaishou.com/d/home/fcACLdpfuv6XV1dlBNTteRGp2
    // 如有新增，需要先与后端和客户端进行确认
    shareId: string; // 分享链接的唯一 id，用来跟踪数据，格式为 分享人UID_分享的时间戳
    shareUserId: string; // 分享人的 uid
    shareSourceId: string; // 内容 id
    shareSourceOwner: string; // 内容的创作者 id
    shareSourceType: string; // 分享源的类型
    shareDeviceId: string; // 分享人的设备 id
}

export function callApp(options?: CallAppOption) {
    const {
        channel = '',

        shareId = '',
        shareUserId = '',
        shareSourceId = '',
        shareSourceOwner = '',
        shareSourceType = '',
        shareDeviceId = '',
    } = options || {};
    if (isIOS) {
        Toast.show({
            text: $k18n('iOS unavailable'),
        });
        return;
    }

    const labelQueryObj = {
        shareId,
        shareUserId,
        shareSourceId,
        shareSourceOwner,
        shareSourceType,
        shareDeviceId,
    };

    const labelQueryStr = encodeURIComponent(JSON.stringify(labelQueryObj));

    openScheme(
        `ktok://krn?bundleId=TopickForyou&categoryName=Todos&componentName=Detail&itemId=${shareSourceId}&adgroup=${channel}&label=${labelQueryStr}&openSource=share`
    ).catch(err => {
        window.location.href = `https://topick.go.link?adj_t=1hq9tmyw&adj_adgroup=${channel}&adj_label=${labelQueryStr}`;
    });
}

export const raceVisibilitychangeAndTimeout = (timeout = 3000) => {
    let haveChange = false;
    const property = 'hidden';
    const eventName = 'visibilitychange';

    const timerPromise = new Promise(resolve => {
        // page 事件处理函数
        const pageChange = e => {
            haveChange = true;

            if (
                document[property] ||
                e.hidden ||
                document.visibilityState === 'hidden'
            ) {
                resolve(OpenStatus.SUCCESS);
            } else {
                resolve(OpenStatus.UNKNOWN);
            }
            document.removeEventListener(eventName, pageChange);
        };
        document.addEventListener(eventName, pageChange, false);

        // 兜底，定时检测
        setTimeout(() => {
            if (haveChange) {
                return;
            }
            document.removeEventListener(eventName, pageChange);

            if (!document.hidden && !haveChange) {
                resolve(OpenStatus.FAILED);
            } else {
                resolve(OpenStatus.UNKNOWN);
            }
        }, timeout);
    });
    return timerPromise;
};

export const iframeCall = (url: string, timeout = 2000) => {
    const iframe = document.createElement('iframe');

    iframe.setAttribute('src', url);
    iframe.setAttribute('style', 'display:none');
    document.body.appendChild(iframe);
    setTimeout(() => {
        document.body.removeChild(iframe);
    }, timeout);
};

export const openScheme = (scheme: string, config: any = {}) => {
    // 延时判断
    return new Promise((resolve, reject) => {
        raceVisibilitychangeAndTimeout(config.timeout).then(status => {
            if (status === OpenStatus.SUCCESS) {
                resolve(true);
            } else {
                reject(false);
            }
        });
        // locationCall在无法拉起的时候会弹窗报错，但safari无法通过iframeCall拉起
        // if (isInternalApp) {
        //     window.location.href = scheme;
        // } else {
        iframeCall(scheme);
        // }
    });
};
